import React from "react"
import PersonsStyled from "./styles/PersonsStyles"
import linkedin from "../../static/linkedin.svg"
import emailImg from "../../static/email.svg"
const PersonSingle = ({ email, linkedIn, img, quotation }) => {
  return (
    <PersonsStyled>
      <div className="container">
        <div className="person__container">
          <div className="person__description">
            <p dangerouslySetInnerHTML={{ __html: quotation }}></p>
            <a href={`mailto:${email}`} className="person__email">
              <img src={emailImg} alt="email" />
              {email}
            </a>
            <a href={linkedIn} className="person__linkedin">
              <img src={linkedin} alt="linkedin" />
            </a>
          </div>
          <div className="person__image">
            <img src={img} alt="person" />
          </div>
        </div>
      </div>
    </PersonsStyled>
  )
}

export default PersonSingle
